export const AccidentRoute = {
  BASE: 'base',
  CAMPAIGN: 'campaign',
  SURVEILLANCE_ROUTE: 'surveillanceRoute',
  EDIT: 'edit',
};
